export default __webpack_public_path__ + "static/media/eletric4.b0d94aed.jpeg";